import Index from "~/pages/automation/screens/IndexScreen.vue";
import Show from "~/pages/automation/screens/ShowScreen.vue";
import CreateOrEdit from "~/pages/automation/screens/CreateOrEditScreen.vue";
import EditGlobal from "~/pages/automation/screens/EditGlobalScreen.vue";

export default [
  {
    path: "/",
    component: Index,
    name: "index",
  },
  {
    path: "/create",
    component: CreateOrEdit,
    name: "create",
  },
  {
    path: "/:automation",
    component: Show,
    name: "show",
    props: { isGlobal: false },
  },
  {
    path: "/:automation/edit",
    component: CreateOrEdit,
    name: "edit",
  },
  {
    path: "/global/:automation",
    component: Show,
    name: "global.show",
    props: { isGlobal: true },
  },
  {
    path: "/global/:automation/edit",
    component: EditGlobal,
    name: "global.edit",
  },
];
